<template>
  <v-layout column class="batch-form">
    <v-container text-xs-center>
      <h2 class="title">Change Password</h2>
    </v-container>
    <form>
      <v-container grid-list-md class="padding-top">
        <v-layout row wrap>
          <v-flex xs12>
            <v-text-field label="Old Password"
              type="password"
              v-model="form.old_password"
              @input="$v.form.old_password.$touch()"
              @blur="$v.form.old_password.$touch()"
              :error-messages="getFormErrorMessage('old_password')"
            ></v-text-field>
          </v-flex>
          <v-flex xs12>
            <v-text-field label="New Password"
              type="password"
              v-model="form.new_password"
              @input="$v.form.new_password.$touch()"
              @blur="$v.form.new_password.$touch()"
              :error-messages="getFormErrorMessage('new_password')"
            ></v-text-field>
          </v-flex>
          <v-flex xs12>
            <v-text-field label="Confirm New Password"
              type="password"
              v-model="form.confirm_password"
              @input="$v.form.confirm_password.$touch()"
              @blur="$v.form.confirm_password.$touch()"
              :error-messages="getFormErrorMessage('confirm_password')"
            ></v-text-field>
          </v-flex>
        </v-layout>
      </v-container>
    </form>
    <v-layout row wrap>
      <v-container class="padding-top">
        <v-flex xs12>
          <v-btn @click="validateChangePasswordForm()" raised block large color="primary" class="btn">save</v-btn>
        </v-flex>
        <v-flex xs12>
          <v-btn @click="handleClose()" flat block large color="primary" class="btn">cancel</v-btn>
        </v-flex>
      </v-container>
    </v-layout>
  </v-layout>
</template>

<script>
import { required, minLength, sameAs } from 'vuelidate/lib/validators'

export default {
  name: 'ChangePasswordForm',
  data () {
    return {
      formValidationErrorMsg: {},
      form: {
        old_password: '',
        new_password: '',
        confirm_password: ''
      }
    }
  },
  validations () {
    return {
      form: {
        old_password: { required },
        new_password: { required, minLength: minLength(8) },
        confirm_password: { required, sameAsPassword: sameAs('new_password') }
      }
    }
  },

  methods: {
    getFormErrorMessage (field) {
      let errors = []

      if (!this.$v.form[field].$dirty) return errors
      for (let key in this.$v.form[field].$params) {
        // Add more key here is needed for other type of error messages
        if (key === 'required') !this.$v.form[field].required && errors.push('This field is is required.')
        if (key === 'minLength') !this.$v.form[field].minLength && errors.push('Requires at least 8 characters')
        if (key === 'sameAsPassword') !this.$v.form[field].sameAsPassword && errors.push('Password need to be identical')
      }

      if (this.formValidationErrorMsg[field]) {
        errors.push(this.formValidationErrorMsg[field][0])
      }

      return errors
    },

    handleClose () {
      this.$emit('on-close-dialog')
    },

    validateChangePasswordForm () {
      if (this.$v.form.$invalid) {
        this.$v.form.$touch()
      } else {
        this.changePassword()
      }
    },

    changePassword () {
      this.$store.dispatch('changePassword', this.form).then(() => {
        this.$store.dispatch('showSnackBar', { message: 'Password changed successfully!' })
        this.handleClose()
      }).catch((err) => {
        for (let key in err) {
          this.formValidationErrorMsg[key] = err[key]
        }
        this.$v.$reset()
        this.$v.$touch()
      })
    }
  }
}

</script>

<style lang="scss" scoped>
.farm-shipment-form{
  padding: 5px 7px;
  .title{
    font-weight: 400;
    font-size: 24px !important;
  }
  .padding-top{
    padding-top: 0;
  }
  .btn{
    font-size: 18px;
    font-weight: 500;
  }
}
</style>
